import React from 'react';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import { Avatar } from '@bufferapp/ui';
import styles from '../css/ChannelFilter.css';

const AvatarWrapper = styled.span`
  margin: 4px 0;
`;

export const onSelectAllClick = ({
  setChannels,
  channels,
  allChannelsAreSelected = false,
}) => {
  // Unselect all channels
  if (allChannelsAreSelected) {
    setChannels([]);
    // Select all channels
  } else {
    const channelsIdArray = channels.map((channel) => channel.id);
    setChannels(channelsIdArray);
  }
};

/* channelsSelected state has to be passed through the onItemClick function as the current state,
   otherwise this keeps the old state it was generated with. */
export const onSelectChannelClick = ({
  currentState,
  setChannels,
  channelId,
}) => {
  // Unselect channel if it was selected
  if (currentState.includes(channelId)) {
    setChannels(currentState.filter((item) => item !== channelId));
    // Select channel
  } else {
    setChannels([...currentState, channelId]);
  }
};

const ChannelInfo = (channel) => {
  return ReactDOMServer.renderToString(
    <div className={styles.wrapper}>
      <p className={styles.title}>{channel.name}</p>
      {channel.locationData?.location && (
        <p className={styles.description}>{channel.locationData?.location}</p>
      )}
      {channel.serverUrl && (
        <p className={styles.description}>{channel.serverUrl}</p>
      )}
    </div>
  );
};

export const getCustomChannels = ({
  channels,
  setChannels,
  channelsSelected,
}) => {
  const items = [];
  const allChannelsAreSelected = channelsSelected.length === channels.length;

  // Select all option
  const allChannelsItem = {
    id: 'all',
    name: 'All channels',
    onItemClick: () =>
      onSelectAllClick({
        setChannels,
        channels,
        allChannelsAreSelected,
      }),
    selected: allChannelsAreSelected,
    hideOnSearch: true,
  };
  items.push(allChannelsItem);
  // Each channel option
  channels.forEach((channel) => {
    const itemProfile = {
      ...channel,
      component: ChannelInfo,
      icon: (
        <AvatarWrapper>
          <Avatar
            src={channel.avatar}
            fallbackUrl="https://s3.amazonaws.com/buffer-ui/Default+Avatar.png"
            alt={channel.name}
            size="small"
            type="social"
            network={channel.service}
          />
        </AvatarWrapper>
      ),
      onItemClick: ({ currentState }) =>
        onSelectChannelClick({
          setChannels,
          channelId: channel.id,
          currentState,
        }),
      selected: channelsSelected.includes(channel.id),
    };
    items.push(itemProfile);
  });

  return items;
};
